import actions from './action';

const initState = {
  loading: false,
  message: null,
  buttonLoading: false,
  error: null,
  totalData: null,
  show: false
};


export default function clientReducer(state = initState, action) {
  switch (action.type) {

    case actions.GET_CLIENT_DATA:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_CLIENT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        totalData: action.payload.totalData
      };
    case actions.GET_CLIENT_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }

}